import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Icon, Input, Row, Col, Modal, Select, Spin, Tag, InputNumber, message } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReactComponent from '../ReactComponent';
import {
	updateTemplateManagement,
} from '../../actions/work-report-actions';
import templateManagementService from '../../services/WorkReport/template-management-service';
import WorkReportTemplate from './WorkReportTemplate';

const typeMap = [ "","日报", "周报", "月报"];
const webConfig = require ('../../config.json');


class TemplateManagementDetail extends ReactComponent {

	moduleName = "workReport";
	childModuleName = "templateManagement";

	actions = {
		selectAction: templateManagementService.selectTemplateManagementDetail,
		createAction: templateManagementService.createTemplateManagement,
	}

	state = {
		dataStatus: "unload",
		data: {
			template: [],
			name: "",
			type_id: 1
		},
		filters: {}
	}

	componentWillMount() {
		let id = this.props.routing.location.pathname.split('/')[3];
		if ("0" === id) {
			this.setState({
				dataStatus: "loaded",
				currentIndex: null
			})
		}else{
			let dataReloaded = false
			this.actions.selectAction({modelId: id}, res => {
				dataReloaded = true;
				res.data.template = JSON.parse(res.data.template);
				this.setState({
					dataStatus: "loaded",
					currentIndex: 1,
					data: res.data
				})}, err => this.setState({
					dataStatus: "error"
				}))
				setTimeout(() => {
					if (!dataReloaded) {
						this.setState({
							dataStatus: "loading"
						});
					}
				}, 100);
		}
	}

	editReportContent = () => {}

	deleteItem = index => Modal.confirm({
		title: '确定删除选中的内容么?',
		okText: '确认',
		cancelText: '取消',
		onOk: () => this.setState({
			data: {
				...this.state.data,
				template: [
					...this.state.data.template.slice(0, index),
					...this.state.data.template.slice(index + 1)
				]
			}
		}),
		onCancel: () => {}
	})

	changeTitleTitle = (index, event) => this.setState({
		data: {
			...this.state.data,
			template: [
					...this.state.data.template.slice(0, index),
					{
						...this.state.data.template[index],
						title: event.target.value
					},
					...this.state.data.template.slice(index + 1)
			]
		}
	})

	changeRowsRows = (index, value) => {
		let copyHeaders = [], copyValues = [];
		for (let i = 0; i < value; i++) {
			if (i === value-1) {
				copyHeaders.push({title: "", width: 27-value*3});
			}else{
				copyHeaders.push({title: "", width: 3});
			}
			if (this.state.data.template[index].headers[i]) {
				copyHeaders[i].title = this.state.data.template[index].headers[i].title;
			}
		}
		for (var i = 0; i < this.state.data.template[index].values.length; i++) {
			let valueItem = [];
			for (let i = 0; i < value; i++) {
				valueItem.push(null);
			}
			copyValues.push(valueItem);
		}
		this.setState({
			data: {
				...this.state.data,
				template: [
						...this.state.data.template.slice(0, index),
						{
							...this.state.data.template[index],
							headers: [...copyHeaders],
							values: [...copyValues]
						},
						...this.state.data.template.slice(index + 1)
				]
			}		
		})		
	}

	changeRowsColumns = (index, value) => {
		let copyValues = [];
		for (let i = 0; i < value; i ++) {
			copyValues.push(this.state.data.template[index].values[0]);
		}
		this.setState({
			data: {
				...this.state.data,
				template: [
						...this.state.data.template.slice(0, index),
						{
							...this.state.data.template[index],
							values: [...copyValues]
						},
						...this.state.data.template.slice(index + 1)
				]
			}		
		})		
	}

	changeRowsTitle = (index, headerIndex, event) => {
		this.setState({
			data: {
				...this.state.data,
				template: [
					...this.state.data.template.slice(0, index),
					{
						...this.state.data.template[index],
						headers: [
							...this.state.data.template[index].headers.slice(0, headerIndex),
							{
								...this.state.data.template[index].headers[headerIndex],
								title: event.target.value
							},
							...this.state.data.template[index].headers.slice(headerIndex + 1)
						]
					},
					...this.state.data.template.slice(index + 1)
				]
			}		
		})	
	}

	changeRowsWidth = (index, headerIndex, value) => {
		this.setState({
			data: {
				...this.state.data,
				template: [
					...this.state.data.template.slice(0, index),
					{
						...this.state.data.template[index],
						headers: [
							...this.state.data.template[index].headers.slice(0, headerIndex),
							{
								...this.state.data.template[index].headers[headerIndex],
								width: value
							},
							...this.state.data.template[index].headers.slice(headerIndex + 1)
						]
					},
					...this.state.data.template.slice(index + 1)
				]
			}		
		})	
	}

	changeColumnColumns = (index, value) => {
		let copyChildren = [];
		for (let i = 0; i < value; i++ ) {
			copyChildren.push({"title": "", value: null});
			if (this.state.data.template[index].children[i]) {
				copyChildren[i].title = this.state.data.template[index].children[i].title;
			}
		}
		this.setState({
			data: {
				...this.state.data,
				template: [
						...this.state.data.template.slice(0, index),
						{
							...this.state.data.template[index],
							height: Math.ceil(value/4) * 80 + "px",
							children: [...copyChildren]
						},
						...this.state.data.template.slice(index + 1)
				]
			}		
		})	
	}

	changeColumnTitle = (index, childIndex, event) => {
		this.setState({
			data: {
				...this.state.data,
				template: [
					...this.state.data.template.slice(0, index),
					{
						...this.state.data.template[index],
						children: [
							...this.state.data.template[index].children.slice(0, childIndex),
							{
								...this.state.data.template[index].children[childIndex],
								title: event.target.value
							},
							...this.state.data.template[index].children.slice(childIndex + 1)
						]
					},
					...this.state.data.template.slice(index + 1)
				]
			}		
		})
	}

	changeColumnsColumns = (index, value) => {
		let copyChildren = [];
		for (let i = 0; i < value; i++ ) {
			copyChildren.push({"title": "", value: null});
			if (this.state.data.template[index].children[i]) {
				copyChildren[i].title = this.state.data.template[index].children[i].title;
			}
		}
		this.setState({
			data: {
				...this.state.data,
				template: [
						...this.state.data.template.slice(0, index),
						{
							...this.state.data.template[index],
							height: value * 40 + "px",
							children: [...copyChildren]
						},
						...this.state.data.template.slice(index + 1)
				]
			}		
		})	
	}

	changeTableRows = (index, value) => {
		let copyHeaders = [], copyValues = [];
		for (let i = 0; i < value; i++) {
			if (i === value-1) {
				copyHeaders.push({title: "", width: 27-value*3});
			}else{
				copyHeaders.push({title: "", width: 3});
			}
			if (this.state.data.template[index].headers[i]) {
				copyHeaders[i].title = this.state.data.template[index].headers[i].title;
			}
		}
		for (var i = 0; i < this.state.data.template[index].values.length; i++) {
			let valueItem = [];
			for (let i = 0; i < value; i++) {
				valueItem.push(null);
			}
			copyValues.push(valueItem);
		}
		this.setState({
			data: {
				...this.state.data,
				template: [
						...this.state.data.template.slice(0, index),
						{
							...this.state.data.template[index],
							headers: [...copyHeaders],
							values: [...copyValues]
						},
						...this.state.data.template.slice(index + 1)
				]
			}		
		})	
	}

	changeTableColumns = (index, value) => {
		let copyColumns = [], copyValues = [];
		for (let i = 0;i < value; i++) {
			copyColumns.push("");
			if (this.state.data.template[index].columns[i]) {
				copyColumns[i] = this.state.data.template[index].columns[i];
			}
		}
		for (let i = 0;i < value;i ++) {
			let valueItem = [];
			for (let j = 0; j < this.state.data.template[index].headers.length - 1; j++) {
				valueItem.push(null);
			}
			copyValues.push(valueItem);
		}
		this.setState({
			data: {
				...this.state.data,
				template: [
						...this.state.data.template.slice(0, index),
						{
							...this.state.data.template[index],
							columns: [...copyColumns],
							values: [...copyValues]
						},
						...this.state.data.template.slice(index + 1)
				]
			}		
		})
	}

	changeTableColumn = (index, columnIndex, event) => this.setState({
		data: {
			...this.state.data,
			template: [
				...this.state.data.template.slice(0, index),
				{
					...this.state.data.template[index],
					columns: [
						...this.state.data.template[index].columns.slice(0, columnIndex),
						event.target.value,
						...this.state.data.template[index].columns.slice(columnIndex + 1)
					]
				},
				...this.state.data.template.slice(index + 1)
			]
		}		
	})

	addTemplateItem = item => {
		switch (item) {
			case "title":
				this.setState({
					data: {
						...this.state.data,
						template: [
							...this.state.data.template,
							{type: "title", title: "标题"}
						]
					}
				})
				break;
			case "row":
				this.setState({
					data: {
						...this.state.data,
						template: [
							...this.state.data.template,
							{type: "row", title: "单行标题", values: [""]}
						]
					}
				})
				break;
			case "rows":
				this.setState({
					data: {
						...this.state.data,
						template: [
							...this.state.data.template,
							{
								type: "rows",
								headers: [
									{title: "多行标题一", width: 12},
									{title: "多行标题二", width: 12},
								],
								values: [["", ""],["", ""]]
							}
						]
					}
				})
				break;
			case "column":
				this.setState({
					data: {
						...this.state.data,
						template: [
							...this.state.data.template,
							{
								type: "column",
								title: "单列标题",
								height: "80px",
								children: [
									{title: "单列标题一", value: ""},
									{title: "单列标题二", value: ""},
									{title: "单列标题三", value: ""},
									{title: "单列标题四", value: ""}
								]
							}
						]
					}
				})
				break;
			case "columns":
				this.setState({
					data: {
						...this.state.data,
						template: [
							...this.state.data.template,
							{
								type: "columns",
								title: "多列标题",
								height: "160px",
								children: [
									{title: "多列标题一", value: ""},
									{title: "多列标题二", value: ""},
									{title: "多列标题三", value: ""},
									{title: "多列标题四", value: ""}
								]
							}
						]
					}
				})
				break;
			case "table":
				this.setState({
					data: {
						...this.state.data,
						template: [
							...this.state.data.template,
							{
								type: "table",
								headers: [
									{title: "项目", width: 4},
									{title: "表头一", width: 5},
									{title: "表头二", width: 5},
									{title: "表头三", width: 5},
									{title: "表头四", width: 5}
								],
								columns: ["项目一", "项目二", "项目三", "项目四"],
								values: [
									["", "", "", ""],
									["", "", "", ""],
									["", "", "", ""],
									["", "", "", ""]
								]
							}
						]
					}
				})
				break;
				case "table_education":
				this.setState({
					data: {
						...this.state.data,
						template: [
							...this.state.data.template,
							{
								type: "table_education",
								headers: [
									{title: "老师", width: 3},
									{title: "外教", width: 3},
									{title: "班级", width: 3},
									{title: "学生人数", width: 3},
									{title: "班级进度", width: 7},
									{title: "时间", width: 5},
								],
								columns: [" ", " ", " ", " ", " ", " "],
								values: [
									[" ", " ", " ", " "," "],
									[" ", " ", " ", " "," "],
									[" ", " ", " ", " "," "],
									[" ", " ", " ", " "," "],
									[" ", " ", " ", " "," "],
									[" ", " ", " ", " "," "],
									[" ", " ", " ", " "," "],
								]
							}
						]
					}
				})
				break;
			default:
		}
	}

	setTemplateName = event => this.setState({
		data: {
			...this.state.data,
			name: event.target.value
		}
	})

	setTemplateType = value => this.setState({
		data: {
			...this.state.data,
			type_id: value
		}
	})

	saveWorkTemplate = () => {
		if ('' === this.state.data.name) {
			message.error("请输入模版名称！");
			return;
		}
		if (0 === this.state.data.template.length) {
			message.error("请选择模版内容！");
			return;
		}
		let data = {
			...this.state.data,
			template: JSON.stringify(this.state.data.template)
		}
		if (this.state.currentIndex) {
			templateManagementService.updateTemplateManagement(data, res => {
				if (res.data.Success) {
					message.success("保存模版成功!");
				}else{
					message.error("保存模版失败!" + res.data.Errors[0]);
				}
			})
		}else{
			templateManagementService.createTemplateManagement(data, res => {
				if (res.data.Success) {
					message.success("添加模版成功!");
				}else{
					message.error("添加模版失败!" + res.data.Errors[0]);
				}
			})
		}
	}

	render() {
		return (
			<div>
				<div className="app-module-item">
					<div style={{marginBottom: "20px"}}>
						<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
							<Link to="/report/template-management">
								<Button type="primary">
									<Icon type="arrow-left" />
									<span>返回</span>
								</Button>
							</Link>
						</div>
						{this.props.access.templateManagement.u_value && <div>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<Button type="primary" onClick={this.addTemplateItem.bind(this, "title")}>
									<Icon type="plus-circle-o" />
									<span>添加标题模块</span>
								</Button>
							</div>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<Button type="primary" onClick={this.addTemplateItem.bind(this, "row")}>
									<Icon type="plus-circle-o" />
									<span>添加单行模块</span>
								</Button>
							</div>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<Button type="primary" onClick={this.addTemplateItem.bind(this, "rows")}>
									<Icon type="plus-circle-o" />
									<span>添加多行模块</span>
								</Button>
							</div>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<Button type="primary" onClick={this.addTemplateItem.bind(this, "column")}>
									<Icon type="plus-circle-o" />
									<span>添加单列模块</span>
								</Button>
							</div>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<Button type="primary" onClick={this.addTemplateItem.bind(this, "columns")}>
									<Icon type="plus-circle-o" />
									<span>添加多列模块</span>
								</Button>
							</div>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<Button type="primary" onClick={this.addTemplateItem.bind(this, "table")}>
									<Icon type="plus-circle-o" />
									<span>添加表格模块</span>
								</Button>
							</div>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<Button type="primary" onClick={this.addTemplateItem.bind(this, "table_education")}>
									<Icon type="plus-circle-o" />
									<span>添加表格模块(教学部)</span>
								</Button>
							</div>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<Button type="primary" onClick={this.saveWorkTemplate}>
									<Icon type="edit" />
									<span>保存</span>
								</Button>
							</div>
						</div>}
						<div style={{clear: "both"}}></div>
					</div>
				</div>
				<Row>
					<Col span={12}>
						<div className="app-module-item" style={{margin: "10px"}}>
							<div style={{margin: "0px 0px 10px"}}>
								<span style={{marginRight: "20px"}}>模版名称: </span>
								<Input value={this.state.data.name}
								 style={{width: "400px"}}
								 onChange={this.setTemplateName}/>
							</div>
							<div style={{margin: "0px 0px 10px"}}>
								<span style={{marginRight: "20px"}}>模版类型: </span>
								<Select value={this.state.data.type_id}
									style={{width: "400px"}}
									onSelect={this.setTemplateType} >
									{typeMap.map((type, index) => {
										if (0 !== index) {
											return (
												<Select.Option key={index}
													value={index} >
													{type}
												</Select.Option>)
										}
										return null;
									})}
								</Select>
							</div>
							{(()=> {
								switch (this.state.dataStatus) {
									case "reload":
									case "loaded":
										return (
												<div>
													{/*JSON.stringify(this.state.data.template)*/}
													{this.state.data.template.map((item, index) => {
														switch (item.type) {
															case "table":
																return (
																		<div key={index}>
																			<div style={{marginBottom: "5px"}}>
																				<Tag color="blue">表格元素</Tag>
																				{this.props.access.templateManagement.d_value && <Tag color="orange"
																					onClick={this.deleteItem.bind(this, index)}>删除</Tag>}
																			</div>
																			<div>
																				<span style={{margin: "0px 10px"}}>行数:</span>
																				<InputNumber value={item.headers.length}
																					min={2} max={8}
																					style={{width:"100px"}}
																					onChange={this.changeTableRows.bind(this, index)} />
																				<span style={{margin: "0px 10px"}}>列数:</span>
																				<InputNumber value={item.columns.length}
																					style={{width:"100px"}}
																					min={1}
																					onChange={this.changeTableColumns.bind(this, index)} />
																				<span style={{color:"red", margin: "0px 10px"}}>
																					所有表头宽度总和应为24
																				</span>
																			</div>
																			<div style={{marginTop: "10px"}}>表头元素:</div>
																			{item.headers.map((header, headerIndex) => {
																				return (<div key={headerIndex} style={{margin: "5px 5px 0px 0px"}}>
																					<Input value={header.title}
																						style={{width:"300px"}}
																						onChange={this.changeRowsTitle.bind(this, index, headerIndex)} />
																					<span style={{margin: "0px 10px"}}>宽度:</span>
																					<InputNumber value={header.width}
																						style={{width:"100px"}}
																						onChange={this.changeRowsWidth.bind(this, index, headerIndex)} />
																				</div>)
																			})}
																			<div style={{marginTop: "10px"}}>列元素:</div>
																			{item.columns.map((column, columnIndex) => {
																				return (<div key={columnIndex} style={{margin: "5px 5px 0px 0px"}}>
																					<Input value={column}
																						style={{width:"300px"}}
																						onChange={this.changeTableColumn.bind(this, index, columnIndex)} />
																				</div>)
																			})}
																			<hr />
																		</div>);
																			case "table_education":
																				return (
																						<div key={index}>
																							<div style={{marginBottom: "5px"}}>
																								<Tag color="blue">表格元素</Tag>
																								{this.props.access.templateManagement.d_value && <Tag color="orange"
																									onClick={this.deleteItem.bind(this, index)}>删除</Tag>}
																							</div>
																							<div>
																								<span style={{margin: "0px 10px"}}>行数:</span>
																								<InputNumber value={item.headers.length}
																									min={2} max={8}
																									style={{width:"100px"}}
																									onChange={this.changeTableRows.bind(this, index)} />
																								<span style={{margin: "0px 10px"}}>列数:</span>
																								<InputNumber value={item.columns.length}
																									style={{width:"100px"}}
																									min={1}
																									onChange={this.changeTableColumns.bind(this, index)} />
																								<span style={{color:"red", margin: "0px 10px"}}>
																									所有表头宽度总和应为24
																								</span>
																							</div>
																							<div style={{marginTop: "10px"}}>表头元素:</div>
																							{item.headers.map((header, headerIndex) => {
																								return (<div key={headerIndex} style={{margin: "5px 5px 0px 0px"}}>
																									<Input value={header.title}
																										style={{width:"300px"}}
																										onChange={this.changeRowsTitle.bind(this, index, headerIndex)} />
																									<span style={{margin: "0px 10px"}}>宽度:</span>
																									<InputNumber value={header.width}
																										style={{width:"100px"}}
																										onChange={this.changeRowsWidth.bind(this, index, headerIndex)} />
																								</div>)
																							})}
																							<hr />
																						</div>);
															case "row":
																return (
																		<div key={index}>
																			<div style={{marginBottom: "5px"}}>
																				<Tag color="blue">单行元素</Tag>
																				{this.props.access.templateManagement.d_value && <Tag color="orange"
																					onClick={this.deleteItem.bind(this, index)}>删除</Tag>}
																			</div>
																			<div>
																				<span style={{margin: "0px 10px"}}>标题:</span>
																				<Input value={item.title}
																					style={{width:"300px"}}
																					onChange={this.changeTitleTitle.bind(this, index)} />
																			</div>
																			<hr />
																		</div>);
															case "rows":
																return (
																		<div key={index}>
																			<div style={{marginBottom: "5px"}}>
																				<Tag color="blue">多行元素</Tag>
																				{this.props.access.templateManagement.d_value && <Tag color="orange"
																					onClick={this.deleteItem.bind(this, index)}>删除</Tag>}	
																			</div>
																			<div>
																				<span style={{margin: "0px 10px"}}>行数:</span>
																				<InputNumber value={item.headers.length}
																					min={2} max={8}
																					style={{width:"100px"}}
																					onChange={this.changeRowsRows.bind(this, index)} />
																				<span style={{margin: "0px 10px"}}>列数:</span>
																				<InputNumber value={item.values.length}
																					style={{width:"100px"}}
																					min={1}
																					onChange={this.changeRowsColumns.bind(this, index)} />
																				<span style={{color:"red", margin: "0px 10px"}}>
																					所有标题宽度总和应为24
																				</span>
																			</div>
																			{item.headers.map((header, headerIndex) => {
																				return (<div key={headerIndex} style={{margin: "5px 5px 0px 0px"}}>
																					<span style={{margin: "0px 10px"}}>标题:</span>
																					<Input value={header.title}
																						style={{width:"300px"}}
																						onChange={this.changeRowsTitle.bind(this, index, headerIndex)} />
																					<span style={{margin: "0px 10px"}}>宽度:</span>
																					<InputNumber value={header.width}
																						style={{width:"100px"}}
																						onChange={this.changeRowsWidth.bind(this, index, headerIndex)} />
																				</div>)
																			})}
																			<hr />
																		</div>);
															case "column":
																return (
																		<div key={index}>
																			<div style={{marginBottom: "5px"}}>
																				<Tag color="blue">单列元素</Tag>
																				{this.props.access.templateManagement.d_value && <Tag color="orange"
																					onClick={this.deleteItem.bind(this, index)}>删除</Tag>}	
																			</div>
																			<div>
																				<span style={{margin: "0px 10px"}}>标题:</span>
																				<Input value={item.title}
																					style={{width:"300px"}}
																					onChange={this.changeTitleTitle.bind(this, index)} />
																				<span style={{margin: "0px 10px"}}>列数:</span>
																				<InputNumber value={item.children.length}
																					min={1}
																					style={{width:"100px"}}
																					onChange={this.changeColumnColumns.bind(this, index)} />
																			</div>
																			<Row>
																			{item.children.map((child, childIndex) => (
																				<Col span={6} key={childIndex}>
																					<div style={{margin: "5px 5px 0px"}}>
																						<Input value={child.title}
																							style={{width:"100%"}}
																							onChange={this.changeColumnTitle.bind(this, index, childIndex)} />
																					</div>
																				</Col>
																			))}
																			</Row>
																			<hr />
																		</div>);
															case "columns":
																return (
																		<div key={index}>
																			<div style={{marginBottom: "5px"}}>
																				<Tag color="blue">单列元素</Tag>
																				{this.props.access.templateManagement.d_value && <Tag color="orange"
																					onClick={this.deleteItem.bind(this, index)}>删除</Tag>}
																			</div>
																			<div>
																				<span style={{margin: "0px 10px"}}>标题:</span>
																				<Input value={item.title}
																					style={{width:"300px"}}
																					onChange={this.changeTitleTitle.bind(this, index)} />
																				<span style={{margin: "0px 10px"}}>列数:</span>
																				<InputNumber value={item.children.length}
																					min={1}
																					style={{width:"100px"}}
																					onChange={this.changeColumnsColumns.bind(this, index)} />
																			</div>
																			<Row>
																			{item.children.map((child, childIndex) => (
																				<Col span={6} key={childIndex}>
																					<div style={{margin: "5px 5px 0px"}}>
																						<Input value={child.title}
																							style={{width:"100%"}}
																							onChange={this.changeColumnTitle.bind(this, index, childIndex)} />
																					</div>
																				</Col>
																			))}
																			</Row>
																			<hr />
																		</div>);
															case "title":
																return (
																		<div key={index}>
																			<div style={{marginBottom: "5px"}}>
																				<Tag color="blue">标题元素</Tag>
																				{this.props.access.templateManagement.d_value && <Tag color="orange"
																					onClick={this.deleteItem.bind(this, index)}>删除</Tag>}	
																			</div>
																			<div>
																				<span style={{margin: "0px 10px"}}>标题:</span>
																				<Input value={item.title}
																					style={{width:"300px"}}
																					onChange={this.changeTitleTitle.bind(this, index)} />
																			</div>
																			<hr />
																		</div>
																	);
															default:
																return null
														}
													})}
												</div>
											);
									case "loading":
									case "unload":
										return (
											<div style={{textAlign:'center', margin: '100px 0px'}}>
												<Spin size="large" />
											</div>);
									case "error":
										return (
											<div style={{textAlign:'center', margin: '100px 0px'}}>
												{webConfig.httpFetchErrorInformation}
											</div>);
									default :
										return null;
								}
							})()}
						</div>
					</Col>
					<Col span={12}>
						<div className="app-module-item" style={{margin: "10px"}}>
							<h4>预览: </h4>
							<div style={{textAlign: "center"}}>
								<WorkReportTemplate currentData={this.state.data.template}
									editReportContent={this.editReportContent}
									openDetail={true} />
							</div>
						</div>
					</Col>
				</Row>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		workReport: state.workReport,
		routing: state.routing
	}
}

const mapDispatchToProps = {
	updateTemplateManagement,
}

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(TemplateManagementDetail));




// WEBPACK FOOTER //
// ./src/routes/WorkReport/TemplateManagementDetail.js